import api from "./api";

export const listTaxonomy = async () => {
	const { data } = await api.get("products/taxonomy/");
	return data;
};

export const listObjectType = async () => {
	const { data } = await api.get("products/media_category/");
	return data;
};

export const listPartners = async () => {
	const { data } = await api.get("manager/partner/");
	return data;
};

export const listKnowledges = async () => {
	const { data } = await api.get("products/knowledges/");
	return data;
};

export const listModalities = () => {
	// const { data } = await api.get("products/modalities/");
	// return data;

	return [
		{
			id: 1,
			description: "Graduação",
		},
		{
			id: 2,
			description: "Pós-graduação",
		},
		// {
		// 	id: 3,
		// 	description: "Livre",
		// },
		{
			id: 4,
			description: "Técnico",
		},
	];
};

export const listProject = async () => {
	const { data } = await api.get("manager/project/");
	return data;
};
